import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import {
  GEOLOCATION_PERMISSION_STATUS,
  GEOLOCATION_PERMISSION_STATUSES,
} from '@common/constants/storeFinder';
import MessageCard from '@common/components/MessageCard';

const SearchMessage = ({
  isGeolocationMode,
  geolocationPermissionStatus,
  shouldShowResults,
  hasShopResults,
}) => {
  const { t } = useTranslation();

  let searchStatus;

  if (
    isGeolocationMode &&
    geolocationPermissionStatus === GEOLOCATION_PERMISSION_STATUS.DENIED
  ) {
    searchStatus = t(
      'storefinder.otherStores.locationNotAllowed',
      'Du hast die Verwendung von deinem Aktuellen Ort abgeleht.',
    );
  } else if (
    isGeolocationMode &&
    geolocationPermissionStatus === GEOLOCATION_PERMISSION_STATUS.PROMPT
  ) {
    searchStatus = t(
      'storefinder.otherStores.locationPending',
      'Um Stores in Deiner Nähe zu finden musst du die die Standorteinstellungen in Deinem Browser zulassen.',
    );
  } else if (shouldShowResults && !hasShopResults) {
    searchStatus = t(
      'storefinder.otherStores.noStores',
      'Keine Stores gefunden!',
    );
  }

  return searchStatus && <MessageCard>{searchStatus}</MessageCard>;
};

SearchMessage.propTypes = {
  isGeolocationMode: PropTypes.bool.isRequired,
  geolocationPermissionStatus: PropTypes.oneOf(GEOLOCATION_PERMISSION_STATUSES)
    .isRequired,
  shouldShowResults: PropTypes.bool.isRequired,
  hasShopResults: PropTypes.bool.isRequired,
};

export default SearchMessage;
